import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { getChannelPageTableColumnHeaders, getChannelPageTableRows, } from "./getChannelPageTableData.js";
import { useState } from "react";
import { Grid2 } from '@mui/material';
import { getPlatform, useScreenOrientation } from "../../utilities/orientationAndPlatform.js";

export default function ChannelPageTable({...params}) {

    let channelRow = params.row

    //state variables for sizing options
    const [sizeStatus, setSizeStatus] = useState("compact");
    const [sizeVal, setSizeVal] = useState("1em");
    const [desktopTableWidth, setDesktopTableWidth] = useState("50%");

    let callSign = channelRow.call_sign
    let affiliate = channelRow.affiliation

    //rows and columns
    let rows = getChannelPageTableRows(channelRow);
    let columns = getChannelPageTableColumnHeaders(sizeStatus, callSign, affiliate);

    //set styling according to platform and screen orientation
    const orientation = useScreenOrientation()
    var platform = getPlatform()
    var tableWidth = ""
    if (platform === 'mobile' && orientation === 0) tableWidth = "98%";
    else if (platform === 'mobile' && orientation === 90) tableWidth = "60%";
    else if (platform === 'desktop') tableWidth = desktopTableWidth;


    //called when size menu's selected option changes, sets various state variables having to do with component sizing
    function handleSizeChange(newSizeStatus) {
        if (newSizeStatus === "compact") {
            setSizeVal("1rem");
            if (platform !== "mobile") setDesktopTableWidth("50%");
        }
        else if (newSizeStatus === "standard") {
            setSizeVal("1.5rem");
            if (platform !== "mobile") setDesktopTableWidth("75%");
        } 
        else if (newSizeStatus === "comfortable") {
            setSizeVal("2rem");
            if (platform !== "mobile") setDesktopTableWidth("100%");
        }
        setSizeStatus(newSizeStatus);
    }


    return (
        <Grid2 container={true} width={tableWidth} justifyContent={'center'} alignItems={'center'} direction={'row'} id={"ChannelPageTableGrid"} paddingTop={'0.5em'} paddingBottom={'0.5em'}>
            <DataGrid
                //data
                rows={rows}
                columns={columns}
                //formatting
                getEstimatedRowHeight={() => 250}
                getRowHeight={() => "auto"}
                localeText={{ toolbarDensity: "Size" }} //Change density button text from Density to Size
                sx={{ fontSize: sizeVal, width: tableWidth, borderColor: "primary.main" ,'& .MuiDataGrid-scrollbar': {display: 'none' }}}
                //size menu
                density={sizeStatus}
                onDensityChange={(newSizeStatus) => handleSizeChange(newSizeStatus)}
                //disable unused options
                initialState={{ pagination: null }}
                hideFooter={true}
                disableColumnSelector
                disableColumnFilter
                slots={{
                    toolbar: GridToolbar,
                    columnHeaders: () => null,
                    columnsManagement: () => null,
                }}
            />
        </Grid2>
    );
}
